import { render, staticRenderFns } from "./FieldManage.vue?vue&type=template&id=39ddfe82&scoped=true&"
import script from "./FieldManage.vue?vue&type=script&lang=js&"
export * from "./FieldManage.vue?vue&type=script&lang=js&"
import style0 from "./FieldManage.vue?vue&type=style&index=0&id=39ddfe82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ddfe82",
  null
  
)

export default component.exports